export default "__VITE_ASSET__BTmgk$r1__"